import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AppBar, Toolbar } from "@material-ui/core";
import SecondaryButton from '../library/buttons/secondary-button';
import { CalculatorContext } from "../../components/app";
import { COLORS } from "../../styles/constants/colors";
import logoSrc from '../../assets/illustrations/logo.svg';

const useStyles = makeStyles({
  header: {
    backgroundColor: COLORS.WHITE,
    boxShadow: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    height: '72px',
    '@media print': {
      display: 'none',
    }
  },
  headerContent: {
    maxWidth: '1280px',
    width: '100%',
    padding: '0',
    color: 'black',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 40px',
    height: '100%',
  }
});

export default function Header(props) {
  const classes = useStyles();

  const { resetClicked } = useContext(CalculatorContext);
  const handlePrint = () => window.print();

  return (
    <AppBar position="fixed" className={classes.header}>
      <Toolbar className={classes.headerContent}>
        <img
          src={logoSrc}
          width={120}
          height={32}
          alt="Livable logotype"
        />
        <div>
          <SecondaryButton onClick={() => props.handleTourOpen()}>
            Launch walkthrough
          </SecondaryButton>
          <SecondaryButton onClick={() => resetClicked()}>
            Reset all values
          </SecondaryButton>
          <SecondaryButton onClick={handlePrint} colored>
            Print results
          </SecondaryButton>
        </div>
      </Toolbar>
    </AppBar>
  )
}